import { render, staticRenderFns } from "./AsignacionPaquetesModal.vue?vue&type=template&id=6262d038&scoped=true"
import script from "./AsignacionPaquetesModal.vue?vue&type=script&lang=js"
export * from "./AsignacionPaquetesModal.vue?vue&type=script&lang=js"
import style0 from "./AsignacionPaquetesModal.vue?vue&type=style&index=0&id=6262d038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6262d038",
  null
  
)

export default component.exports